import z from "zod";

import { ZSafeDataMap, zUnsafeDataMap } from "../attribute/ZAttrValue";
import { zSysDataHistory } from "../sysData/ZSysData";

export const zValueCatalogCard = z.object({
  id: z.string(),
  displayId: z.number(),
  catalogValueId: z.string(),
  data: zUnsafeDataMap.describe("Имя схемы => {имя атрибута => значение}"),
  ...zSysDataHistory.shape,
});

export type ZValueCatalogCard = z.infer<typeof zValueCatalogCard>;

export type ZValueCatalogCardSafe = Omit<ZValueCatalogCard, "data"> & {
  data: ZSafeDataMap;
};
